export const Screens = [];
export const viewMonitorsXYDeg = {
    values: [],
    //example: values = [[[0, 0], [0, 5], [0, 10]], [[0, 0], [0, 5], [0, 10]]] means that the first block has 3 eccentricities and the second block has 3 eccentricities.
    numberOfMonitorsForCurrentBlock: 0,
    maxNumberOfMonitors: 0,
    currentBlockIndex: 0, // index of the current block
};
